<div class="mxsds">
  <div class="w-100 d-flex justify-content-center flex-column">
    <div class="p-3">
      <h3>Test Name</h3>
      <select class="form-select form-select-lg mb-3 p-2" aria-label=".form-select-lg example"
              (focus)="setSizeForQuizDropdown()"
              (blur)="quizFilterDropdownSize = 1;"
              (change)="quizFilterDropdownSize = 1;" #quiz>
        <option [selected]="!selectedQuizId" value="Test Name">Test Name</option>
        <option class="font-size-decrease"
                *ngFor="let quiz of this.quizzes"
                [selected]="isQuizSelected(quiz.id)" [value]="quiz.id">{{ quiz.name }}
        </option>
      </select>
    </div>
  </div>

  <div class="w-100 d-flex justify-content-center flex-column">
    <div class="p-3">
      <h3>Test Category</h3>
      <select class="form-select form-select-lg mb-3" aria-label=".form-select-lg example"
              (focus)="setSizeForCategoryDropdown()"
              (blur)="resetQuizDropdownSize(1)"
              (change)="resetQuizDropdownSize(1)"
              #category>
        <option [selected]="!selectedTestCategoryId" value="Test Category">Test Category</option>
        <option class="font-size-decrease"
                *ngFor="let category of quizCategories"
                [value]="category.id"
                [selected]="category.id === selectedTestCategoryId">{{ category.name }}
        </option>
      </select>
    </div>
  </div>
</div>
<div class="d-flex" [ngClass]="{'flex-column-reverse pt-13' : isMobile, 'justify-content-end' : !isMobile}">
  <button
          class="btn border-sm rounded-5 m-3 pt-2 mx-2"
          type="button" (click)="resetFilter()">Reset
  </button>
  <button [disabled]="quiz.value === 'Test Name' && category.value === 'Test Category'"
          class="btn btn-primary rounded-5 m-3 pt-2 mx-2"
          type="button" (click)="onFilter(category.value, quiz.value)">Apply
  </button>
</div>
